exports.MVCObject = woosmap.map.MVCObject;
